// extracted by mini-css-extract-plugin
export default {"body":"Body_body__RWYSc"};